/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:22
 * @LastEditTime: 2026-01-30 17:52:50
 * @Description: 调用方式: $const['Common/[name]']
 */
import i18n from '@/i18n'
import { sthFromLang } from '@/utils/base'

const ChinaRegion = {
  北京: '东城,西城,崇文,宣武,朝阳,丰台,石景山,海淀,门头沟,房山,通州,顺义,昌平,大兴,平谷,怀柔,密云,延庆',
  上海: '黄浦,卢湾,徐汇,长宁,静安,普陀,闸北,虹口,杨浦,闵行,宝山,嘉定,浦东,金山,松江,青浦,南汇,奉贤,崇明',
  天津: '和平,东丽,河东,西青,河西,津南,南开,北辰,河北,武清,红挢,塘沽,汉沽,大港,宁河,静海,宝坻,蓟县',
  重庆: '万州,涪陵,渝中,大渡口,江北,沙坪坝,九龙坡,南岸,北碚,万盛,双挢,渝北,巴南,黔江,长寿,綦江,潼南,铜梁,大足,荣昌,壁山,梁平,城口,丰都,垫江,武隆,忠县,开县,云阳,奉节,巫山,巫溪,石柱,秀山,酉阳,彭水,江津,合川,永川,南川',
  河北: '石家庄,邯郸,邢台,保定,张家口,承德,廊坊,唐山,秦皇岛,沧州,衡水',
  山西: '太原,大同,阳泉,长治,晋城,朔州,吕梁,忻州,晋中,临汾,运城',
  内蒙古: '呼和浩特,包头,乌海,赤峰,呼伦贝尔盟,阿拉善盟,哲里木盟,兴安盟,乌兰察布盟,锡林郭勒盟,巴彦淖尔盟,伊克昭盟',
  辽宁: '沈阳,大连,鞍山,抚顺,本溪,丹东,锦州,营口,阜新,辽阳,盘锦,铁岭,朝阳,葫芦岛',
  吉林: '长春,吉林,四平,辽源,通化,白山,松原,白城,延边',
  黑龙江: '哈尔滨,齐齐哈尔,牡丹江,佳木斯,大庆,绥化,鹤岗,鸡西,黑河,双鸭山,伊春,七台河,大兴安岭',
  江苏: '南京,镇江,苏州,南通,扬州,盐城,徐州,连云港,常州,无锡,宿迁,泰州,淮安',
  浙江: '杭州,宁波,温州,嘉兴,湖州,绍兴,金华,衢州,舟山,台州,丽水',
  安徽: '合肥,芜湖,蚌埠,马鞍山,淮北,铜陵,安庆,黄山,滁州,宿州,池州,淮南,巢湖,阜阳,六安,宣城,亳州',
  福建: '福州,厦门,莆田,三明,泉州,漳州,南平,龙岩,宁德',
  江西: '南昌市,景德镇,九江,鹰潭,萍乡,新馀,赣州,吉安,宜春,抚州,上饶',
  山东: '济南,青岛,淄博,枣庄,东营,烟台,潍坊,济宁,泰安,威海,日照,莱芜,临沂,德州,聊城,滨州,菏泽',
  河南: '郑州,开封,洛阳,平顶山,安阳,鹤壁,新乡,焦作,濮阳,许昌,漯河,三门峡,南阳,商丘,信阳,周口,驻马店,济源',
  湖北: '武汉,宜昌,荆州,襄樊,黄石,荆门,黄冈,十堰,恩施,潜江,天门,仙桃,随州,咸宁,孝感,鄂州',
  湖南: '长沙,常德,株洲,湘潭,衡阳,岳阳,邵阳,益阳,娄底,怀化,郴州,永州,湘西,张家界',
  广东: '广州,深圳,珠海,汕头,东莞,中山,佛山,韶关,江门,湛江,茂名,肇庆,惠州,梅州,汕尾,河源,阳江,清远,潮州,揭阳,云浮',
  广西: '南宁,柳州,桂林,梧州,北海,防城港,钦州,贵港,玉林,南宁地区,柳州地区,贺州,百色,河池',
  海南: '海口,三亚',
  四川: '成都,绵阳,德阳,自贡,攀枝花,广元,内江,乐山,南充,宜宾,广安,达川,雅安,眉山,甘孜,凉山,泸州',
  贵州: '贵阳,六盘水,遵义,安顺,铜仁,黔西南,毕节,黔东南,黔南',
  云南: '昆明,大理,曲靖,玉溪,昭通,楚雄,红河,文山,思茅,西双版纳,保山,德宏,丽江,怒江,迪庆,临沧',
  西藏: '拉萨,日喀则,山南,林芝,昌都,阿里,那曲',
  陕西: '西安,宝鸡,咸阳,铜川,渭南,延安,榆林,汉中,安康,商洛',
  甘肃: '兰州,嘉峪关,金昌,白银,天水,酒泉,张掖,武威,定西,陇南,平凉,庆阳,临夏,甘南',
  宁夏: '银川,石嘴山,吴忠,固原',
  青海: '西宁,海东,海南,海北,黄南,玉树,果洛,海西',
  新疆: '乌鲁木齐,石河子,克拉玛依,伊犁,巴音郭勒,昌吉,克孜勒苏柯尔克孜,博 尔塔拉,吐鲁番,哈密,喀什,和田,阿克苏',
  香港: '',
  澳门: '',
  台湾: '台北,高雄,台中,台南,屏东,南投,云林,新竹,彰化,苗栗,嘉义,花莲,桃园,宜兰,基隆,台东,金门,马祖,澎湖'
}

const cityFormatter = data => {
  return data.split(',').map((n, idx) => ({
    label: n,
    value: String(idx)
  }))
}

 export default [
  {
    name: 'AreaCodes',
    value: [
      { cnName: '阿富汗', enName: 'Afghanistan', value: '0093' },
      { cnName: '阿尔巴尼亚', enName: 'Albania', value: '00355' },
      { cnName: '阿尔及利亚', enName: 'Algeria', value: '00213' },
      { cnName: '美属萨摩亚', enName: 'American Samoa', value: '00684' },
      { cnName: '安道尔', enName: 'Andorra', value: '00376' },
      { cnName: '安哥拉', enName: 'Angola', value: '00244' },
      { cnName: '安圭拉', enName: 'Anguilla', value: '001264' },
      { cnName: '安提瓜和巴布达', enName: 'Antigua and Barbuda', value: '001268' },
      { cnName: '阿根廷', enName: 'Argentina', value: '0054' },
      { cnName: '亚美尼亚', enName: 'Armenia', value: '00374' },
      { cnName: '阿鲁巴', enName: 'Aruba I.', value: '00297' },
      { cnName: '澳大利亚', enName: 'Australia', value: '0061' },
      { cnName: '奥地利', enName: 'Austria', value: '0043' },
      { cnName: '阿塞拜疆', enName: 'Azerbaijan', value: '00994' },
      { cnName: '巴哈马', enName: 'Bahamas', value: '001242' },
      { cnName: '巴林', enName: 'Bahrain', value: '00973' },
      { cnName: '孟加拉', enName: 'Bangladesh', value: '00880' },
      { cnName: '巴巴多斯', enName: 'Barbados', value: '001246' },
      { cnName: '白俄罗斯', enName: 'Belarus', value: '00375' },
      { cnName: '比利时', enName: 'Belgium', value: '0032' },
      { cnName: '伯利兹', enName: 'Belize', value: '00501' },
      { cnName: '贝宁', enName: 'Benin', value: '00229' },
      { cnName: '百慕大', enName: 'Bermuda Is.', value: '001441' },
      { cnName: '不丹', enName: 'Bhutan', value: '00975' },
      { cnName: '玻利维亚', enName: 'Bolivia', value: '00591' },
      { cnName: '波斯尼亚和黑塞哥维那（波黑）', enName: 'Bosnia and Herzegovina', value: '00387' },
      { cnName: '博茨瓦纳', enName: 'Botswana', value: '00267' },
      { cnName: '巴西', enName: 'Brazil', value: '0055' },
      { cnName: '英属印度洋领地', enName: 'British Indian Ocean Territory', value: '00246' },
      { cnName: '文莱', enName: 'Brunei Darussalam', value: '00673' },
      { cnName: '保加利亚', enName: 'Bulgaria', value: '00359' },
      { cnName: '布基纳法索', enName: 'Burkina Faso', value: '00226' },
      { cnName: '布隆迪', enName: 'Burundi', value: '00257' },
      { cnName: '柬埔寨', enName: 'Cambodia', value: '00855' },
      { cnName: '喀麦隆', enName: 'Cameroon', value: '00237' },
      { cnName: '佛得角', enName: 'Cape Verde', value: '00238' },
      { cnName: '开曼群岛', enName: 'Cayman Islands', value: '001345' },
      { cnName: '中非共和国', enName: 'Central African Republic', value: '00236' },
      { cnName: '乍得', enName: 'Chad', value: '00235' },
      { cnName: '智利', enName: 'Chile', value: '0056' },
      { cnName: '中国', enName: 'China', value: '0086' },
      { cnName: '哥伦比亚', enName: 'Colombia', value: '0057' },
      { cnName: '科摩罗', enName: 'Comoros', value: '00269' },
      { cnName: '刚果共和国', enName: 'Congo', value: '00242' },
      { cnName: '刚果民主共和国', enName: 'Congo, Democratic Republic of', value: '00243' },
      { cnName: '库克群岛', enName: 'Cook Islands', value: '00682' },
      { cnName: '哥斯达黎加', enName: 'Costa Rica', value: '00506' },
      { cnName: '科特迪瓦', enName: "Cote d'Ivoire", value: '00225' },
      { cnName: '克罗地亚', enName: 'Croatia', value: '00385' },
      { cnName: '古巴', enName: 'Cuba', value: '0053' },
      { cnName: '塞浦路斯', enName: 'Cyprus', value: '00357' },
      { cnName: '捷克', enName: 'Czech Republic', value: '00420' },
      { cnName: '丹麦', enName: 'Denmark', value: '0045' },
      { cnName: '吉布提', enName: 'Djibouti, Republic of', value: '00253' },
      { cnName: '多米尼克', enName: 'Dominica, Commonwealth of', value: '001767' },
      { cnName: '多米尼加', enName: 'Dominican Republic', value: '001809' },
      { cnName: '厄瓜多尔', enName: 'Ecuador', value: '00593' },
      { cnName: '埃及', enName: 'Egypt', value: '0020' },
      { cnName: '萨尔瓦多', enName: 'El Salvador', value: '00503' },
      { cnName: '赤道几内亚', enName: 'Equatorial Guinea', value: '00240' },
      { cnName: '爱沙尼亚', enName: 'Estonia', value: '00372' },
      { cnName: '埃塞俄比亚', enName: 'Ethiopia', value: '00251' },
      { cnName: '福克兰群岛', enName: 'Falkland Islands', value: '00500' },
      { cnName: '法罗群岛', enName: 'Faroe Islands', value: '00298' },
      { cnName: '斐济', enName: 'Fiji', value: '00679' },
      { cnName: '芬兰', enName: 'Finland', value: '00358' },
      { cnName: '法国', enName: 'France', value: '0033' },
      { cnName: '法属圭亚那', enName: 'French Guiana', value: '00594' },
      { cnName: '法属波利尼西亚', enName: 'French Polynesia', value: '00689' },
      { cnName: '加蓬', enName: 'Gabon', value: '00241' },
      { cnName: '冈比亚', enName: 'Gambia', value: '00220' },
      { cnName: '格鲁吉亚', enName: 'Georgia', value: '00995' },
      { cnName: '德国', enName: 'Germany', value: '0049' },
      { cnName: '加纳', enName: 'Ghana', value: '00233' },
      { cnName: '直布罗陀', enName: 'Gibraltar', value: '00350' },
      { cnName: '希腊', enName: 'Greece', value: '0030' },
      { cnName: '格陵兰', enName: 'Greenland', value: '00299' },
      { cnName: '格林纳达', enName: 'Grenada', value: '001473' },
      { cnName: '瓜德罗普岛', enName: 'Guadeloupe', value: '00590' },
      { cnName: '关岛', enName: 'Guam', value: '001671' },
      { cnName: '危地马拉', enName: 'Guatemala', value: '00502' },
      { cnName: '几内亚', enName: 'Guinea', value: '00224' },
      { cnName: '几内亚比绍', enName: 'Guinea-Bissau', value: '00245' },
      { cnName: '圭亚那', enName: 'Guyana', value: '00592' },
      { cnName: '海地', enName: 'Haiti', value: '00509' },
      { cnName: '洪都拉斯', enName: 'Honduras', value: '00504' },
      { cnName: '中国香港', enName: 'Hong Kong, China', value: '00852' },
      { cnName: '匈牙利', enName: 'Hungary', value: '0036' },
      { cnName: '冰岛', enName: 'Iceland', value: '00354' },
      { cnName: '印度', enName: 'India', value: '0091' },
      { cnName: '印度尼西亚', enName: 'Indonesia', value: '0062' },
      { cnName: '伊朗', enName: 'Iran', value: '0098' },
      { cnName: '伊拉克', enName: 'Iraq', value: '00964' },
      { cnName: '爱尔兰', enName: 'Ireland', value: '00353' },
      { cnName: '以色列', enName: 'Israel', value: '00972' },
      { cnName: '意大利', enName: 'Italy', value: '0039' },
      { cnName: '牙买加', enName: 'Jamaica', value: '001876' },
      { cnName: '日本', enName: 'Japan', value: '0081' },
      { cnName: '约旦', enName: 'Jordan', value: '00962' },
      { cnName: '哈萨克斯坦', enName: 'Kazakhstan', value: '0076' },
      { cnName: '肯尼亚', enName: 'Kenya', value: '00254' },
      { cnName: '韩国', enName: 'Korea, Republic of', value: '0082' },
      { cnName: '科威特', enName: 'Kuwait', value: '00965' },
      { cnName: '吉尔吉斯斯坦', enName: 'Kyrgyzstan', value: '00996' },
      { cnName: '老挝', enName: 'Laos', value: '00856' },
      { cnName: '拉脱维亚', enName: 'Latvia', value: '00371' },
      { cnName: '黎巴嫩', enName: 'Lebanon', value: '00961' },
      { cnName: '莱索托', enName: 'Lesotho', value: '00266' },
      { cnName: '利比里亚', enName: 'Liberia', value: '00231' },
      { cnName: '利比亚', enName: 'Libya', value: '00218' },
      { cnName: '列支敦士登', enName: 'Liechtenstein', value: '00423' },
      { cnName: '立陶宛', enName: 'Lithuania', value: '00370' },
      { cnName: '卢森堡', enName: 'Luxembourg', value: '00352' },
      { cnName: '中国澳门', enName: 'Macau, China', value: '00853' },
      { cnName: '马其顿', enName: 'Macedonia', value: '00389' },
      { cnName: '马达加斯加', enName: 'Madagascar', value: '00261' },
      { cnName: '马拉维', enName: 'Malawi', value: '00265' },
      { cnName: '马来西亚', enName: 'Malaysia', value: '0060' },
      { cnName: '马尔代夫', enName: 'Maldives', value: '00960' },
      { cnName: '马里', enName: 'Mali', value: '00223' },
      { cnName: '马耳他', enName: 'Malta', value: '00356' },
      { cnName: '马提尼克', enName: 'Martinique', value: '00596' },
      { cnName: '毛里塔尼亚', enName: 'Mauritania', value: '00222' },
      { cnName: '毛里求斯', enName: 'Mauritius', value: '00230' },
      { cnName: '墨西哥', enName: 'Mexico', value: '0052' },
      { cnName: '密克罗尼西亚', enName: 'Micronesia, Federated States of', value: '00691' },
      { cnName: '摩尔多瓦', enName: 'Moldova', value: '00373' },
      { cnName: '摩纳哥', enName: 'Monaco', value: '00377' },
      { cnName: '蒙古', enName: 'Mongolia', value: '00976' },
      { cnName: '黑山', enName: 'Montenegro', value: '00382' },
      { cnName: '蒙特塞拉特岛', enName: 'Montserrat', value: '001664' },
      { cnName: '摩洛哥', enName: 'Morocco', value: '00212' },
      { cnName: '莫桑比克', enName: 'Mozambique', value: '00258' },
      { cnName: '缅甸', enName: 'Myanmar', value: '0095' },
      { cnName: '纳米比亚', enName: 'Namibia', value: '00264' },
      { cnName: '瑙鲁', enName: 'Nauru', value: '00674' },
      { cnName: '尼泊尔', enName: 'Nepal', value: '00977' },
      { cnName: '荷兰', enName: 'Netherlands', value: '0031' },
      { cnName: '荷属安第列斯', enName: 'Netherlands Antilles', value: '00599' },
      { cnName: '新喀里多尼亚', enName: 'New Caledonia', value: '00687' },
      { cnName: '新西兰', enName: 'New Zealand', value: '0064' },
      { cnName: '尼加拉瓜', enName: 'Nicaragua', value: '00505' },
      { cnName: '尼日尔', enName: 'Niger', value: '00227' },
      { cnName: '尼日利亚', enName: 'Nigeria', value: '00234' },
      { cnName: '诺福克岛', enName: 'Norfolk Island', value: '00672' },
      { cnName: '北马里亚纳群岛', enName: 'Northern Mariana Islands', value: '001670' },
      { cnName: '挪威', enName: 'Norway', value: '0047' },
      { cnName: '阿曼', enName: 'Oman', value: '00968' },
      { cnName: '巴基斯坦', enName: 'Pakistan', value: '0092' },
      { cnName: '帕劳', enName: 'Palau', value: '00680' },
      { cnName: '巴勒斯坦', enName: 'Palestinian Territory', value: '00970' },
      { cnName: '巴拿马', enName: 'Panama', value: '00507' },
      { cnName: '巴布亚新几内亚', enName: 'Papua New Guinea', value: '00675' },
      { cnName: '巴拉圭', enName: 'Paraguay', value: '00595' },
      { cnName: '秘鲁', enName: 'Peru', value: '0051' },
      { cnName: '菲律宾', enName: 'Philippines', value: '0063' },
      { cnName: '波兰', enName: 'Poland', value: '0048' },
      { cnName: '葡萄牙', enName: 'Portugal', value: '00351' },
      { cnName: '波多黎各', enName: 'Puerto Rico', value: '001787' },
      { cnName: '卡塔尔', enName: 'Qatar', value: '00974' },
      { cnName: '留尼旺岛', enName: 'Reunion', value: '00262' },
      { cnName: '罗马尼亚', enName: 'Romania', value: '0040' },
      { cnName: '俄罗斯', enName: 'Russian Federation', value: '0079' },
      { cnName: '卢旺达', enName: 'Rwanda, Republic of', value: '00250' },
      { cnName: '圣基茨与尼维斯', enName: 'Saint Kitts and Nevis', value: '001869' },
      { cnName: '圣卢西亚', enName: 'Saint Lucia', value: '001758' },
      { cnName: '圣皮埃尔和密克隆群岛', enName: 'Saint Pierre and Miquelon', value: '00508' },
      { cnName: '圣文森特和格林纳丁斯', enName: 'Saint Vincent and The Grenadines', value: '00784' },
      { cnName: '萨摩亚', enName: 'Samoa', value: '00685' },
      { cnName: '圣马力诺', enName: 'San Marino, Republic of', value: '00378' },
      { cnName: '圣多美和普林西比', enName: 'Sao Tome and Principe', value: '00239' },
      { cnName: '沙特阿拉伯', enName: 'Saudi Arabia', value: '00966' },
      { cnName: '塞内加尔', enName: 'Senegal', value: '00221' },
      { cnName: '塞尔维亚', enName: 'Serbia', value: '00381' },
      { cnName: '塞舌尔', enName: 'Seychelles', value: '00248' },
      { cnName: '塞拉利昂', enName: 'Sierra Leone', value: '00232' },
      { cnName: '新加坡', enName: 'Singapore', value: '0065' },
      { cnName: '荷属圣马丁', enName: 'Sint Maarten', value: '001721' },
      { cnName: '斯洛伐克', enName: 'Slovakia', value: '00421' },
      { cnName: '斯洛文尼亚', enName: 'Slovenia', value: '00386' },
      { cnName: '所罗门群岛', enName: 'Solomon Islands', value: '00677' },
      { cnName: '索马里', enName: 'Somalia', value: '00252' },
      { cnName: '南非', enName: 'South Africa', value: '0027' },
      { cnName: '南苏丹', enName: 'South Sudan', value: '00211' },
      { cnName: '西班牙', enName: 'Spain', value: '0034' },
      { cnName: '斯里兰卡', enName: 'Sri Lanka', value: '0094' },
      { cnName: '苏丹', enName: 'Sudan', value: '00249' },
      { cnName: '苏里南', enName: 'Suriname', value: '00597' },
      { cnName: '斯威士兰', enName: 'Swaziland', value: '00268' },
      { cnName: '瑞典', enName: 'Sweden', value: '0046' },
      { cnName: '瑞士', enName: 'Switzerland', value: '0041' },
      { cnName: '叙利亚', enName: 'Syria', value: '00963' },
      { cnName: '中国台湾', enName: 'Taiwan, China', value: '00886' },
      { cnName: '塔吉克斯坦', enName: 'Tajikistan', value: '00992' },
      { cnName: '坦桑尼亚', enName: 'Tanzania', value: '00255' },
      { cnName: '泰国', enName: 'Thailand', value: '0066' },
      { cnName: '东帝汶', enName: 'Timor-Leste', value: '00670' },
      { cnName: '多哥', enName: 'Togo', value: '00228' },
      { cnName: '汤加', enName: 'Tonga', value: '00676' },
      { cnName: '特立尼达和多巴哥', enName: 'Trinidad and Tobago', value: '001868' },
      { cnName: '突尼斯', enName: 'Tunisia', value: '00216' },
      { cnName: '土耳其', enName: 'Turkey', value: '0090' },
      { cnName: '土库曼斯坦', enName: 'Turkmenistan', value: '00993' },
      { cnName: '特克斯和凯科斯群岛', enName: 'Turks and Caicos Islands', value: '001649' },
      { cnName: '乌干达', enName: 'Uganda', value: '00256' },
      { cnName: '乌克兰', enName: 'Ukraine', value: '00380' },
      { cnName: '阿联酋', enName: 'United Arab Emirates', value: '00971' },
      { cnName: '英国', enName: 'United Kingdom', value: '0044' },
      { cnName: '美国和加拿大', enName: 'United States & Canada', value: '001' },
      { cnName: '乌拉圭', enName: 'Uruguay', value: '00598' },
      { cnName: '乌兹别克斯坦', enName: 'Uzbekistan', value: '00998' },
      { cnName: '瓦努阿图', enName: 'Vanuatu', value: '00678' },
      { cnName: '委内瑞拉', enName: 'Venezuela', value: '0058' },
      { cnName: '越南', enName: 'Vietnam', value: '0084' },
      { cnName: '英属维京群岛', enName: 'Virgin Islands, British', value: '001284' },
      { cnName: '美属维京群岛', enName: 'Virgin Islands, U.S.', value: '001340' },
      { cnName: '也门', enName: 'Yemen', value: '00967' },
      { cnName: '赞比亚', enName: 'Zambia', value: '00260' },
      { cnName: '津巴布韦', enName: 'Zimbabwe', value: '00263' }
    ]
  },
  {
    name: 'GoodsCodeOptions',
    value: [
      { productType: 5, value: 'csec-aps', image: require('@/assets/images/doc_app.png') },
      { productType: 2, value: 'csec-cs-new', image: require('@/assets/images/doc_floodshield.png') }
    ]
  },
   {
     name: 'StaticMenuData',
     value: [
       {
         code: 'StaticDomainManagement',
         nameCn: '域名管理',
         nameEn: 'Domain Management',
         children: [
           {
             nameCn: '域名配置',
             nameEn: 'Hostname Configuration',
             url: '/domainManage/singleDomain/domainConfig',
             platform:'csec',
             menuType: 'static',
             code: 'domainManage',
             permission:'EDIT_SINGLE_DOMAIN_CONFIG' },
           {
             nameCn: '加速设置',
             nameEn: 'Acceleration Configuration',
             url: '/domainManage/singleDomain/accelerationConfig',
             platform:'csec',
             menuType: 'static',
             code: 'domainManage',
             permission: 'EDIT_SINGLE_ACCELERATION_CONFIG' },
           {
             nameCn: '安全策略',
             nameEn: 'Security Configuration',
             url: `${process.env.VUE_APP_WAAP_URL}/index#/domainProtection/securityPolicy/basic`,
             platform:'waap',
             code: 'domainProtection',
             menuType: 'static',
             permission:'EDIT_SINGLE_DOMAIN_SECURITY_POLICY'
           }
         ]
       }
     ]
   },
  {
    name: 'CascaderAddress',
    value: [
      {
        label: i18n.t('common.china'),
        value: '0',
        children: Object.keys(ChinaRegion).map((province, provinceIdx) => {
          if (ChinaRegion[province]) {
            return {
              label: province,
              value: String(provinceIdx),
              children: cityFormatter(ChinaRegion[province])
            }
          } else {
            return {
              label: province,
              value: String(provinceIdx)
            }
          }
        })
      },
      {
        label: i18n.t('website.overseas'),
        value: '1'
      }
    ]
  },
  {
    name: 'WaapDictKeys',
    value: [
      'waap_policyType',
      'waap_waf_protect_mode',
      'waap_waf_operate_mode',
      'waap_retCodeEnum',
      'waap_domain_access_ddos_mode'
    ]
  },
  {
    name: 'PageSizes',
    value: [10, 50, 100, 300, 500]
  },
  {
    name: 'SearchCol',
    value: { xs: 24, sm: 24, md: 12, lg: 6, xl: 4, class: 'mb-12' }
  },
  {
    name: 'DaterPickerCol',
    value: { xs: 24, sm: 24, md: 12, lg: 6, xl: 4 }
  },
  {
    name: 'BinaryYesNoOptions',
    value: [
      { label: i18n.t('common.yes'), value: 1 }, // 是
      { label: i18n.t('common.no'), value: 0 } // 否
    ]
  },
  {
    name: 'OpenCloseOptions',
    value: [
      { label: i18n.t('common.open'), value: 1 }, // 开启
      { label: i18n.t('common.close'), value: 0 } // 关闭
    ]
  },
  // 一行排列详情（一般用于表格中显示多行数据，中文一行排列，英文上下排列）
  {
    name: 'DetailDescriptions',
    value: (direction = sthFromLang('horizontal', 'vertical')) => {
      return {
        column: 1,
        class: 'detail-el-descriptions',
        direction
      }
    }
  },
  // 上下排列详情表单
  {
    name: 'DetailForm',
    value: (gap = '12px') => {
      const config = {
        'form-type': 'detail',
        'label-position': 'top',
        'label-suffix': i18n.t('common.colon'),
        'item-margin-bottom': gap
      }
      return config
    }
  },
  // 页面表单
  {
    name: 'PageForm',
    value: () => {
      const config = {
        'label-position': 'top',
        class: 'ml-40'
      }
      return config
    }
  },
  // 域名接入卡片中的表单
  {
    name: 'CardForm',
    value: (colon = false) => {
      return {
        'item-margin-bottom': 'small',
        'label-position': 'top',
        'label-suffix': colon ? i18n.t('common.colon') : '',
        class: 'detail-form-in-card'
      }
    }
  },
  // 文本域
  {
    name: 'Textarea',
    value: (rows = 3, limit = 0) => {
      if (limit) {
        return {
          type: 'textarea',
          rows: rows,
          'show-word-limit': true,
          maxlength: limit
        }
      } else {
        return {
          type: 'textarea',
          rows: rows
        }
      }
    }
  },
  // 禁止自动填充
  {
    name: 'Autocomplete',
    value: (name, val = 'off') => ({
      autocomplete: val,
      name
    })
  },
  {
    name: 'ClientStatus',
    value: [
      { label: i18n.t('common.available'), value: 1, colorClazz: 'text-color-success' },
      { label: i18n.t('common.disabled'), value: 0, colorClazz: 'text-color-info' }
    ]
  },
  {
    name: 'SignFormConfig',
    value: () => ({
      'label-position': 'top',
      'item-margin-bottom': '16px'
    })
  },
   {
     name: 'ProductSwitcStaty',
     value: [
       '/document'
     ]
   }
]
